// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"152293f9","952":"780e9c38"}[chunkId] + ".chunk.js";
};